import { Link } from 'react-router-dom';

const quickCategories = [
  { name: '都市', icon: 'ri-building-2-line', desc: '职场与生活' },
  { name: '古装', icon: 'ri-ancient-gate-line', desc: '王朝与传奇' },
  { name: '悬疑', icon: 'ri-search-eye-line', desc: '烧脑推理' },
  { name: '爱情', icon: 'ri-heart-3-line', desc: '甜蜜心动' },
  { name: '科幻', icon: 'ri-planet-line', desc: '未来想象' },
  { name: '家庭', icon: 'ri-home-heart-line', desc: '温情治愈' },
  { name: '犯罪', icon: 'ri-shield-user-line', desc: '警匪缉凶' },
  { name: '武侠', icon: 'ri-sword-line', desc: '快意江湖' },
];

export default function CategoryQuick() {
  return (
    <section className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-14">
      <div className="mb-6 flex items-end justify-between">
        <div>
          <h2 className="font-heading text-xl font-semibold text-foreground-950 md:text-2xl">
            按类型浏览
          </h2>
          <p className="mt-1 text-sm text-foreground-600">快速找到你感兴趣的剧集题材</p>
        </div>
        <Link
          to="/category"
          className="hidden items-center gap-1 whitespace-nowrap text-sm text-primary-600 transition-colors hover:text-primary-700 sm:flex cursor-pointer"
        >
          全部类型
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 md:gap-4">
        {quickCategories.map((c) => (
          <Link
            key={c.name}
            to={`/category?genre=${encodeURIComponent(c.name)}`}
            className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 md:p-4 cursor-pointer"
          >
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${c.icon} text-xl`}></i>
            </span>
            <span className="min-w-0">
              <span className="block font-heading text-sm font-semibold text-foreground-950">
                {c.name}
              </span>
              <span className="block truncate text-xs text-foreground-500">{c.desc}</span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}